import { render, staticRenderFns } from "./ConferenceDigitalComp.vue?vue&type=template&id=36d0711f&scoped=true"
import script from "./ConferenceDigitalComp.vue?vue&type=script&lang=js"
export * from "./ConferenceDigitalComp.vue?vue&type=script&lang=js"
import style0 from "./ConferenceDigitalComp.vue?vue&type=style&index=0&id=36d0711f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d0711f",
  null
  
)

/* custom blocks */
import block0 from "./ConferenceDigitalComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports